<template>
  <div class="lightTheme">
    <cross-words
        :words="wordsProp"
        @sendGrid="getGrid"
    ></cross-words>

    <div>
      <div class="grid" :key="gridCheck">
        <div class="row" v-for="(line, indexLine) in currentGrid" :key="'l'+indexLine">
          <div v-for="(square, indexColumn) in line" :key="'c'+indexColumn">
            <div class="cell" :class="[square !== '' ? 'letterCell clickable' :'', isInCurrentWord(indexLine,indexColumn)? 'in-word-cell':'', isCurrentLetter(indexLine,indexColumn)? 'current-letter-cell':'', isStart(indexLine,indexColumn)? 'starting-cell clickable':'', isLetterCheck(indexLine, indexColumn)? 'letter-check' : '']"
                 @click="selectAxis(indexLine, indexColumn)"
            >
              <div>
                <div class="cell-number" v-if="getWordNumber(indexLine,indexColumn) !== false">
                  {{ getWordNumber(indexLine,indexColumn) }}
                </div>
                {{square}}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="axisSelection">
      <div :class="[currentAxisType === 'horizontal' ? 'activeAxis' : 'inactiveAxis clickable']" @click="toggleAxis('horizontal')">
        Horizontal
      </div>
      <div class="horizontal-definitions">
        <div v-for="(element, index) in words.filter((element => element.axis !== undefined))" :key="index" class="clickable"
             @click="selectAxisFromDefinition(element.axis)"
        >
          <div v-if="element.axis.direction ==='horizontal'"
               :class="[(element.axis.indexLine === currentAxis.indexLine && element.axis.indexColumn === currentAxis.indexColumn && currentAxis.direction === 'horizontal') ? 'selected-definition' : '']">{{ getWordNumber(element.axis.indexLine, element.axis.indexColumn) }}. {{element.definition}}</div>
        </div>
      </div>
      <div :class="[currentAxisType === 'vertical' ? 'activeAxis' : 'inactiveAxis clickable']" @click="toggleAxis('vertical')">
        vertical
      </div>
      <div class="vertical-definitions">
        <div v-for="(element, index) in words.filter((element => element.axis !== undefined))" :key="index" class="clickable"
             @click="selectAxisFromDefinition(element.axis)"
        >
          <div v-if="element.axis.direction ==='vertical'"
               :class="[(element.axis.indexLine === currentAxis.indexLine && element.axis.indexColumn === currentAxis.indexColumn && currentAxis.direction === 'vertical') ? 'selected-definition' : '']">{{  getWordNumber(element.axis.indexLine, element.axis.indexColumn) }}. {{element.definition}}</div>
        </div>
      </div>

    </div>

    <div class="clearWord">
      <div class="clickable"
           @click="clearWord()"
      >
        Effacer le mot courrant
      </div>
    </div>

    <div class="clearLetter">
      <div :class="[currentWord.length>0 ? 'clickable' : '']"
           @click="clearLetter(getLastLetterIndex(currentWord))"
      >
        <i class="fas fa-long-arrow-alt-left"></i>
      </div>
    </div>

    <div class="validateGrid">
      <div class="validate clickable" v-if="!gridResolved"
           @click="validate()"
      >
        Valider la grille
      </div>
      <div v-else>
        Bravo !
      </div>
    </div>

    <keyboard class="keyboard"
              @letterSuggested="newLetter"
              :proposedLetters="[]"></keyboard>
  </div>

</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "zoneTest",

  components: {
    crossWords: () => import(/* webpackPrefetch: true */ '@/components/crossWords.vue'),
    keyboard: () => import(/* webpackPrefetch: true */ '@/components/keyboard26')
  },

  created () {
    this.words.forEach((element) => {
      this.wordsProp.push(element.englishWord.toUpperCase())
    })

    window.addEventListener('keypress', this.keyboardPress);
  },

  destroyed() {
    window.removeEventListener('keypress', this.keyboardPress);
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },

  methods: {
    getGrid(grid) {
      this.answerGrid = grid.slice()
      this.currentGrid = this.answerGrid.slice()
      this.currentGrid.forEach((line, indexLine) => {
        line.forEach((cell, indexColumn) => {
          if(cell !== '') {
            // Si la case avant était inexistante ou vide,
            // et que la case suivante contient aussi une lettre,
            // on est sur le début d'un mot
            if(indexColumn === 0) {
              if(this.currentGrid[indexLine][indexColumn+1] !== '') {
                this.addWordToList(indexLine, indexColumn, 'horizontal')
              }
            }
            // Sinon si on n'est pas sur la dernière case,
            // et que la case précédente et vide
            // et que la case suivante est une lettre, on est sur un début de mot
            else if(indexColumn < this.currentGrid[indexLine].length-1) {
              if(this.currentGrid[indexLine][indexColumn-1] === '' && this.currentGrid[indexLine][indexColumn+1] !== '') {
                this.addWordToList(indexLine, indexColumn, 'horizontal')
              }
            }
          }
        })
      })

      this.currentGrid.forEach((line, indexLine) => {
        line.forEach((cell, indexColumn) => {
          if(cell !== '') {
            // Si la case avant était inexistante ou vide,
            // et que la case suivante contient aussi une lettre,
            // on est sur le début d'un mot
            if(indexLine === 0) {
              if(this.currentGrid[indexLine+1][indexColumn] !== '') {
                this.addWordToList(indexLine, indexColumn, 'vertical')
              }
            }
            // Sinon si on n'est pas sur la dernière case,
            // et que la case précédente et vide
            // et que la case suivante est une lettre, on est sur un début de mot
            else if(indexLine < this.currentGrid.length-1) {
              if(this.currentGrid[indexLine-1][indexColumn] === '' && this.currentGrid[indexLine+1][indexColumn] !== '') {
                this.addWordToList(indexLine, indexColumn, 'vertical')
              }
            }
          }
        })
      })

      this.currentGrid.forEach((line, indexLine) => {
        line.forEach((cell, indexColumn) => {
          if(cell !== '') {
            this.currentGrid[indexLine][indexColumn] = ' '
          }
        })
      })

      this.seekCrossing()
    },

    isStart(line,column) {
      let startinWord = false
      this.wordsStart.forEach((element) => {
        if(element.indexLine === line && element.indexColumn === column)
        {
          startinWord = true
          return true
        }
      })

      return startinWord
    },

    isLetterCheck(indexLine, indexColumn) {
      for(let i=0; i<this.wordsStart.length; i++) {
        if(this.wordsStart[i].direction === 'horizontal') {
          if(this.wordsStart[i].indexLine === indexLine) {
            if(indexColumn >= this.wordsStart[i].indexColumn && indexColumn < (this.wordsStart[i].indexColumn + this.wordsStart[i].word.length)) {
              if(this.wordsStart[i].check) {
                return true;
              }
            }
          }
        }
        if(this.wordsStart[i].indexColumn === indexColumn && this.wordsStart[i].direction === 'vertical') {
          if(indexLine >= this.wordsStart[i].indexLine && indexLine < (this.wordsStart[i].indexLine + this.wordsStart[i].word.length)) {
            if(this.wordsStart[i].check) {
              return true;
            }
          }
        }
      }
      return false
    },

    toggleAxis(axis) {
      this.axisSelected = false
      this.currentAxisType = axis
    },

    isInCurrentWord(indexLine, indexColumn) {
      if(this.axisSelected) {
        if(this.currentAxisType === 'horizontal') {
          // On regarde si la cellule fait partie du mot
          if(indexLine === this.currentAxis.indexLine) {
            if(indexColumn >= this.currentAxis.indexColumn && indexColumn < (this.currentAxis.indexColumn + this.currentAxis.word.length)) {
              return true
            }
          }
          return false
        }
        else if(this.currentAxisType === 'vertical') {
          // On regarde si la cellule fait partie du mot
          if(indexColumn === this.currentAxis.indexColumn) {
            if(indexLine >= this.currentAxis.indexLine && indexLine < (this.currentAxis.indexLine + this.currentAxis.word.length)) {
              return true
            }
          }
          return false
        }
      }
      return false

    },

    isCurrentLetter(indexLine, indexColumn) {
      if(this.isInCurrentWord(indexLine, indexColumn)) {
        if(this.currentAxisType === 'horizontal') {
          // On vérifie si la cellule est celle correspondant à la prochaine lettre du mot courrant
          if(this.getFirstSpaceIndex(this.currentWord)+this.currentAxis.indexColumn === indexColumn) {
            return true
          }
          return false
        }
        else if(this.currentAxisType === 'vertical') {
          // On vérifie si la cellule est celle correspondant à la prochaine lettre du mot courrant
          if(this.getFirstSpaceIndex(this.currentWord)+this.currentAxis.indexLine === indexLine) {
            return true
          }
          return false
        }
      }
      return false
    },

    addWordToList(indexLine, indexColumn, direction) {
      if(direction === 'vertical') {
        // On cherche la première case vide sur l'axe vertical
        // pour déterminer la longueur du mot
        let word = '';
        for(let i=indexLine; i<this.currentGrid.length; i++) {
          if(this.currentGrid[i][indexColumn] !== '') {
            word = word + this.currentGrid[i][indexColumn]
          }
          else {
            break
          }
        }

        this.addAxisToList(direction, indexColumn, indexLine, word)
      }

      else if(direction === 'horizontal') {
        // On cherche la première case vide sur l'axe horizontal
        // pour déterminer la longueur du mot
        let word = ''
        for(let i=indexColumn; i<this.currentGrid[indexLine].length; i++) {
          if(this.currentGrid[indexLine][i] !== '') {
            word = word+this.currentGrid[indexLine][i]
          }
          else {
            break
          }
        }

        this.addAxisToList(direction, indexColumn, indexLine, word)
      }
    },

    seekCrossing() {
      this.wordsStart.forEach((word, index) => {
        if(word.direction === 'horizontal') {
          // On regarde également pour chaque axe les axes croisant pour vérifier s'ils sont déjà validés
          this.wordsStart.filter((element => element.direction === 'vertical')).forEach((element) => {
            if(element.indexLine <= word.indexLine && element.indexLine + element.word.length > word.indexLine)
            {
              if(word.indexColumn <= element.indexColumn && word.indexColumn + word.word.length > element.indexColumn) {
                this.wordsStart[index].crossingWords.push(Object.assign({}, element))
              }
            }
          })
        }
        else if(word.direction === 'vertical') {
          // On regarde également pour chaque axe les axes croisant pour vérifier s'ils sont déjà validés
          this.wordsStart.filter((element => element.direction === 'horizontal')).forEach((element) => {
            if(element.indexColumn <= word.indexColumn && element.indexColumn + element.word.length > word.indexColumn) {
              if(word.indexLine <= element.indexLine && word.indexLine + word.word.length > element.indexLine) {
                this.wordsStart[index].crossingWords.push(Object.assign({}, element))
              }
            }
          })
        }
      })
    },

    addAxisToList(direction, indexColumn, indexLine, word) {
      let axis = {
        direction: direction,
        indexColumn: indexColumn,
        indexLine: indexLine,
        word: word,
        check: false,
        crossingWords: []
      }

      this.wordsStart.push(axis)
      for(let i=0; i<this.words.length; i++) {
        if(this.words[i].englishWord.toUpperCase() === word) {

          this.words[i]['axis'] = axis
        }
      }
    },

    selectAxis(indexLine, indexColumn, forcedDirection=false) {
      for(let i=0; i<this.wordsStart.length; i++) {
        if(!forcedDirection || this.currentAxisType === 'horizontal') {
          if(this.wordsStart[i].indexLine === indexLine && this.wordsStart[i].direction === 'horizontal') {
            if(indexColumn >= this.wordsStart[i].indexColumn && indexColumn < (this.wordsStart[i].indexColumn + this.wordsStart[i].word.length)) {
              this.currentAxis = this.wordsStart[i];
              this.currentAxisType = this.currentAxis.direction;
              this.axisSelected = true;
              break
            }
          }
        }
        if(!forcedDirection || this.currentAxisType === 'vertical') {
          if(this.wordsStart[i].indexColumn === indexColumn && this.wordsStart[i].direction === 'vertical') {
            if(indexLine >= this.wordsStart[i].indexLine && indexLine < (this.wordsStart[i].indexLine + this.wordsStart[i].word.length)) {
              this.currentAxis = this.wordsStart[i];
              this.currentAxisType = this.currentAxis.direction;
              this.axisSelected = true;
              break
            }
          }
        }
      }
      if(this.axisSelected) {
        this.getGridWord()
      }
    },

    selectAxisFromDefinition(axis) {
      this.toggleAxis(axis.direction)
      this.selectAxis(axis.indexLine, axis.indexColumn, true)
    },

    getFirstSpaceIndex(wordArray) {
      let firstIndex = -1;
      for(let i=0; i<wordArray.length; i++) {
        if(wordArray[i] === ' ') {
          firstIndex = i;
          break
        }
      }
      return firstIndex
    },

    getLastLetterIndex(wordArray) {
      let lastindex = -1;
      for(let i=wordArray.length-1; i>=0; i--) {
        let pass=false
        if(wordArray[i] !== ' ') {
          // on ne considère pas la lettre si elle fait parti d'un croisement avec un mot validé
          for(let j=0; j<this.currentAxis.crossingWords.length; j++) {
            if(this.currentAxis.direction === 'horizontal') {
              if(this.isLetterCheck(this.currentAxis.indexLine, this.currentAxis.indexColumn+i)) {
                pass=true
                break
              }
            }
            else if(this.currentAxis.direction === 'vertical') {
              if(this.isLetterCheck(this.currentAxis.indexLine+i, this.currentAxis.indexColumn)) {
                pass=true
                break
              }
            }
          }
          if(!pass) {
            lastindex = i;
            break
          }
        }
      }
      return lastindex
    },

    newLetter(letter) {
      if(!this.currentAxis.check && this.getFirstSpaceIndex(this.currentWord) >=0) {
        if(this.axisSelected) {
          if(this.currentAxis.direction === 'horizontal') {
            if(this.isLetterCheck(this.currentAxis.indexLine, this.currentAxis.indexColumn+this.getFirstSpaceIndex(this.currentWord))) {
              // on récupère la lettre du mot validé vertical qui coupe le mot courant ici
              for(let i=0; i<this.currentAxis.crossingWords.length; i++) {
                if(this.currentAxis.crossingWords[i].indexColumn === this.currentAxis.indexColumn +this.getFirstSpaceIndex(this.currentWord)) {
                  let indexLastLetter = this.currentAxis.crossingWords[i].indexLine+this.currentAxis.crossingWords[i].word.length;
                  let diff = indexLastLetter - this.currentAxis.indexLine
                  let indexLetter = indexLastLetter - diff - this.currentAxis.crossingWords[i].indexLine
                  this.currentWord[this.getFirstSpaceIndex(this.currentWord)]=this.currentAxis.crossingWords[i].word.charAt(indexLetter)
                  this.typeWord()
                }
              }
            }
            else {
              this.currentWord.splice(this.getFirstSpaceIndex(this.currentWord), 1, letter).join()
              this.typeWord()
            }
          }
          else if(this.currentAxis.direction === 'vertical') {
            if(this.isLetterCheck(this.currentAxis.indexLine+this.getFirstSpaceIndex(this.currentWord), this.currentAxis.indexColumn)) {
              // on récupère la lettre du mot validé vertical qui coupe le mot courant ici
              for(let i=0; i<this.currentAxis.crossingWords.length; i++) {
                if(this.currentAxis.crossingWords[i].indexLine === this.currentAxis.indexLine+this.getFirstSpaceIndex(this.currentWord)) {
                  let indexLastLetter = this.currentAxis.crossingWords[i].indexColumn+this.currentAxis.crossingWords[i].word.length;
                  let diff = indexLastLetter - this.currentAxis.indexColumn
                  let indexLetter = indexLastLetter - diff - this.currentAxis.crossingWords[i].indexColumn
                  this.currentWord[this.getFirstSpaceIndex(this.currentWord)]=this.currentAxis.crossingWords[i].word.charAt(indexLetter)
                  this.typeWord()

                  this.currentWord[this.getFirstSpaceIndex(this.currentWord)]=letter
                  this.typeWord()
                  break
                }
              }
            }
            else {
              this.currentWord[this.getFirstSpaceIndex(this.currentWord)]=letter
              this.typeWord()
            }
          }
        }
      }
    },

    keyboardPress(event) {
      if(this.slugify(String.fromCharCode(event.keyCode)).toUpperCase().charCodeAt(0) >= 65 && this.slugify(String.fromCharCode(event.keyCode)).toUpperCase().charCodeAt(0) <= 65+26) {
        this.newLetter(this.slugify(String.fromCharCode(event.keyCode)).toUpperCase())
      }
    },

    typeWord() {
      if(this.currentAxisType === 'horizontal') {
        for(let i=0; i<this.currentWord.length; i++) {
          this.$set(this.currentGrid[this.currentAxis.indexLine], this.currentAxis.indexColumn+i, this.currentWord[i])
          this.$set(this.currentGrid, this.currentAxis.indexLine, this.currentGrid[this.currentAxis.indexLine])
        }
      }
      else if(this.currentAxisType === 'vertical') {
        for(let i=0; i<this.currentWord.length; i++) {
          this.$set(this.currentGrid[this.currentAxis.indexLine+i], this.currentAxis.indexColumn, this.currentWord[i])
          this.$set(this.currentGrid, this.currentAxis.indexLine, this.currentGrid[this.currentAxis.indexLine])
        }
      }
    },

    clearWord() {
      if(!this.currentAxis.check) {
        if(this.currentAxisType === 'horizontal') {
          for(let i=0; i<this.currentAxis.word.length; i++) {
            if(!this.isLetterCheck(this.currentAxis.indexLine, this.currentAxis.indexColumn+i)) {
              this.clearLetter(i)
            }
            /*this.$set(this.currentGrid[this.currentAxis.indexLine], this.currentAxis.indexColumn+i, ' ')
            this.$set(this.currentGrid, this.currentAxis.indexLine, this.currentGrid[this.currentAxis.indexLine])*/
          }
        }
        else if(this.currentAxisType === 'vertical') {
          for(let i=this.currentAxis.word.length-1; i>=0; i--) {
            if(!this.isLetterCheck(this.currentAxis.indexLine+i, this.currentAxis.indexColumn)) {
              this.clearLetter(i)
            }
            /*this.$set(this.currentGrid[this.currentAxis.indexLine+i], this.currentAxis.indexColumn, ' ')
            this.$set(this.currentGrid, this.currentAxis.indexLine, this.currentGrid[this.currentAxis.indexLine])*/
          }
        }
        //this.currentWord = []
      }
    },

    clearLetter(letterIndex) {
      if(!this.currentAxis.check && letterIndex >=0) {
        if(this.currentAxisType === 'horizontal') {
          if(!this.isLetterCheck(this.currentAxis.indexLine, this.currentAxis.indexColumn+letterIndex)) {
            this.$set(this.currentGrid[this.currentAxis.indexLine], this.currentAxis.indexColumn+letterIndex, ' ')
            this.$set(this.currentGrid, this.currentAxis.indexLine, this.currentGrid[this.currentAxis.indexLine])
            this.currentWord[letterIndex] = ' '
          }
          else {
            this.$set(this.currentGrid[this.currentAxis.indexLine], this.currentAxis.indexColumn+letterIndex-1, ' ')
            this.$set(this.currentGrid, this.currentAxis.indexLine, this.currentGrid[this.currentAxis.indexLine])
            this.currentWord[letterIndex-1] = ' '
          }

        }
        else if(this.currentAxisType === 'vertical') {
          if(!this.isLetterCheck(this.currentAxis.indexLine+letterIndex, this.currentAxis.indexColumn)) {
            this.$set(this.currentGrid[this.currentAxis.indexLine+letterIndex], this.currentAxis.indexColumn, ' ')
            this.$set(this.currentGrid, this.currentAxis.indexLine, this.currentGrid[this.currentAxis.indexLine])
            this.currentWord[letterIndex] = ' '
          }
          else {
            this.$set(this.currentGrid[this.currentAxis.indexLine+letterIndex-1], this.currentAxis.indexColumn, ' ')
            this.$set(this.currentGrid, this.currentAxis.indexLine, this.currentGrid[this.currentAxis.indexLine])
            this.currentWord[letterIndex-1] = ' '
          }
        }
      }
    },

    getGridWord() {
      this.currentWord = []
      if(this.currentAxisType === 'horizontal') {
        for(let i=0; i<this.currentAxis.word.length; i++) {
          /*if(this.currentGrid[this.currentAxis.indexLine][this.currentAxis.indexColumn+i] === ' ') {
            break
          }*/
          this.currentWord[i]=this.currentGrid[this.currentAxis.indexLine][this.currentAxis.indexColumn+i]
        }
      }
      else if(this.currentAxisType === 'vertical') {
        for(let i=0; i<this.currentAxis.word.length; i++) {
          /*if(this.currentGrid[this.currentAxis.indexLine+i][this.currentAxis.indexColumn] === ' ') {
            break
          }*/
          this.currentWord[i]=this.currentGrid[this.currentAxis.indexLine+i][this.currentAxis.indexColumn]
        }
      }
    },

    getWordNumber(indexLine, indexColumn) {
      const words = this.words.filter(element => element.axis !== undefined)
      for(let i=0; i<words.length; i++) {
        if(indexLine === words[i].axis.indexLine && indexColumn === words[i].axis.indexColumn) {
          return i+1
        }
      }
      return false
    },

    checkWordInGrid(word) {
      if(word.direction === 'horizontal') {
        for(let i=0; i<word.word.length; i++) {
          if(this.answerGrid[word.indexLine][word.indexColumn+i] !== word.word.charAt(i)) {
            return false
          }
        }
        return true
      }
      else if(word.direction === 'vertical') {
        for(let i=0; i<word.word.length; i++) {
          if(this.answerGrid[word.indexLine+i][word.indexColumn] !== word.word.charAt(i)) {
            return false
          }
        }
        return true
      }
      return false
    },

    validate() {
      let allCkeck = true;
      // On parcours la grille
      this.wordsStart.forEach((word, index, array) => {
        if(this.checkWordInGrid(word)) {
          array[index].check = true
          this.wordsStart[index].check = true
        }
        else {
          allCkeck = false;
        }
      })
      if(allCkeck) {
        this.gridResolved = true;
      }
      this.gridCheck++;
    },

    slugify(str) {
      const map = {
        'a' : 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        'e' : 'é|è|ê|ë|É|È|Ê|Ë',
        'i' : 'í|ì|î|ï|Í|Ì|Î|Ï',
        'o' : 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        'u' : 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        'c' : 'ç|Ç',
        'n' : 'ñ|Ñ',
        'oe' : 'œ'
      };

      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern);
      }

      return str;
    },
  },

  data: function () {
    return {
      answerGrid: [],
      currentGrid: [],
      wordsStart: [],
      currentAxisType: 'horizontal',
      currentWord: [],
      currentAxis: {},
      axisSelected: false,
      gridCheck: 0,
      gridResolved: false,
      wordsProp: [],
      words: [

        {
          englishWord: 'hpy',
          definition: 'a domesticated carnivorous mammal that typically has a long snout, an acute sense of smell, non-retractable claws, and a barking, howling, or whining voice.',
          french : 'chien',
        },
        {
          englishWord: 'nap',
          definition: 'a short sleep, especially during the day.',
          french : 'sieste',
        },
        {
          englishWord: 'fuck',
          definition: 'have sex with (someone).',
          french : 'enculer',
        },
        {
          englishWord: 'work',
          definition: 'be engaged in physical or mental activity in order to achieve a result; do work.',
          french : 'travailler',
        },
        {
          englishWord: 'house',
          definition: 'the place where one lives permanently, especially as a member of a family or household.',
          french : 'maison',
        },
        {
          englishWord: 'flexibility',
          definition: 'the quality of bending easily without breaking.',
          french : 'flexibilité',
        },
        {
          englishWord: 'seriously',
          definition: 'in a solemn or considered manner.',
          french : 'sérieusement',
        },
        {
          englishWord: 'vocabulary',
          definition: 'the body of words used in a particular language.',
          french : 'vocabulaire',
        },
        {
          englishWord: 'funnel',
          definition: 'a tube or pipe that is wide at the top and narrow at the bottom, used for guiding liquid or powder into a small opening.',
          french : 'entonnoir',
        },
        {
          englishWord: 'background',
          definition: 'the part of a picture, scene, or design that forms a setting for the main figures or objects, or appears furthest from the viewer.',
          french : 'fond-d\'écran',
        },
      ]
    }
  }
}
</script>

<style scoped>

.grid {
  display: grid;
  grid-template-rows: auto;
  grid-auto-flow: row;
}

.row {
  width: max-content;
  display: grid;
  grid-template-columns: auto;
  grid-auto-flow: column;
}

.cell {
  position: relative;
  text-align: center;
  font-size: 1vw;
  color: black;
  width: 1.5vw;
  height: 1.5vw;
}

.letterCell {
  box-sizing: border-box;
  border: 1px solid grey;
}

.starting-cell {
  background-color: #e0f6e0;
}

.inactiveAxis {
  font-weight: bold;
}

.in-word-cell {
  background-color: #fce3be;
}

.current-letter-cell {
  box-sizing: border-box;
  /*background-color: white;*/
  border: 3px solid grey;
}

.cell-number {
  position: absolute;
  top: 0px;
  left: 0px;
  font-size: 0.5vw;
}

.letter-check {
  color: #5560aa;
  font-weight: bold;
}

.selected-definition {
  background-color: #fce3be;
}

@media screen and (max-device-width: 767px) {
  .grid {
    width: max-content;
    display: grid;
    grid-template-columns: auto;
    grid-auto-flow: column;
  }

  .row {
    display: grid;
    grid-template-rows: auto;
    grid-auto-flow: row;
  }

  .cell {
    position: relative;
    text-align: center;
    font-size: 4vw;
    color: black;
    width: 6vw;
    height: 6vw;
  }
}
</style>